var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDeleteBasketRed(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.28516 1H10.7137V1.88235H7.28516V1Z",
    fill: "#EE4E4E",
    stroke: "#EE4E4E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3 2.76465H15",
    stroke: "#EE4E4E",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3.85742 5.41211L4.76882 14.6603H4.76855C4.80396 15.0275 4.96944 15.3678 5.23308 15.6153C5.49646 15.8629 5.83949 16.0001 6.19516 16.0003H11.8051C12.1602 16.0003 12.5025 15.8638 12.7661 15.6167C13.0295 15.37 13.1956 15.0306 13.2317 14.6642L14.1431 5.41601L3.85742 5.41211Z",
    fill: "#EE4E4E",
    stroke: "#EE4E4E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteBasketRed);
export default __webpack_public_path__ + "static/media/deleteBasketRed.e89c4bdb55f87d27ff1ee2699d29bf83.svg";
export { ForwardRef as ReactComponent };